/**
 * This error handling is responsible for processing
 * errors that occur outside of React Router
 * and unhandled promise rejections.
 */
export const initUncaughtErrorHandling = (handler) => {
    window.addEventListener('error', handler);
};
export const initUncaughtUnhandledRejectionHandling = (handler) => {
    window.addEventListener('unhandledrejection', handler);
};
